<template>
    <div>
        <div class="card card-default">
            <div class="card-header">Setup MSSQL Server</div>

            <div class="card-body">

                <div class="alert alert-success" v-if="form.successful">
                    Information has been updated!
                </div>

                <form role="form" @submit.prevent="submit">

                    <div class="form-group row">
                        <label class="col-md-4 col-form-label text-md-right">Host</label>

                        <div class="col-md-6">
                            <input type="text" class="form-control" name="host" v-model="form.host"
                                   :class="{'is-invalid': form.errors.has('host')}" placeholder="127.0.0.1">
                            <span class="invalid-feedback" v-show="form.errors.has('host')">
                                {{ form.errors.get('host') }}
                            </span>
                        </div>
                    </div>

                    <div class="form-group row">
                        <label class="col-md-4 col-form-label text-md-right">Port</label>

                        <div class="col-md-6">
                            <input type="text" class="form-control" name="port" v-model="form.port"
                                   :class="{'is-invalid': form.errors.has('port')}" placeholder="1433">
                            <span class="invalid-feedback" v-show="form.errors.has('port')">
                                {{ form.errors.get('port') }}
                            </span>
                        </div>
                    </div>

                    <div class="form-group row">
                        <label class="col-md-4 col-form-label text-md-right">Username</label>

                        <div class="col-md-6">
                            <input type="text" class="form-control" name="username" v-model="form.username"
                                   :class="{'is-invalid': form.errors.has('username')}" placeholder="sa">
                            <span class="invalid-feedback" v-show="form.errors.has('username')">
                                {{ form.errors.get('username') }}
                            </span>
                        </div>
                    </div>

                    <div class="form-group row">
                        <label class="col-md-4 col-form-label text-md-right">Password</label>

                        <div class="col-md-6">
                            <input type="password" class="form-control" name="password" v-model="form.password"
                                   :class="{'is-invalid': form.errors.has('password')}" placeholder="********">
                            <span class="invalid-feedback" v-show="form.errors.has('password')">
                            {{ form.errors.get('password') }}
                        </span>
                        </div>
                    </div>

                    <div class="form-group row mb-0">
                        <div class="offset-md-4 col-md-6">
                            <button type="submit" class="btn btn-primary" :disabled="form.busy">
                                <span v-if="form.busy">
                                    <i class="fa fa-btn fa-spinner fa-spin"></i> saving
                                </span>

                                <span v-else>
                                    Save
                                </span>
                            </button>
                        </div>
                    </div>
                </form>

            </div>
        </div>

        <div class="alert alert-danger" v-if="databaseConnection === false">
            Couldn't connect to the database. Please, check your configuration.
        </div>

        <importer-new v-if="databaseConnection === true" :databases="databases" @get-databases="getDatabases"></importer-new>
        <importer-list :databases="databases"></importer-list>
    </div>
</template>

<script>
    export default {
        name   : 'mssql-config',
        data   : () => ({
            form              : new SparkForm({
                host    : '',
                port    : '',
                username: '',
                password: '',
            }),
            databaseConnection: null,
            databases: null
        }),
        created() {
            this.getInfo();
            this.checkConnection();
            this.getDatabases();
        },
        methods: {
            checkConnection() {
                axios.get(route('legacy-migration.sql-server.status'))
                     .then(({data}) => this.databaseConnection = data.status);
            },
            getInfo() {
                axios.get(route('legacy-migration.sql-server'))
                     .then(({data}) => this.form = new SparkForm(data));
            },
            submit() {
                Spark.post(route('legacy-migration.sql-server'), this.form)
                     .then(() => {
                         Bus.$emit('databaseSet');
                         this.checkConnection();
                     });
            },
            getDatabases() {
                this.checkConnection();
                axios.get(route('legacy-migration.sql-server.databases'))
                     .then(({data}) => this.databases = data);
            },
        }
    }
</script>
